import Acceptants from "components/shared/acceptants/Acceptants";
import RedeemHero from "./redeemHero/RedeemHero";
import Stores from "./stores/Stores";

import { Above, Background } from "./Redeem.styled";

export default function Redeem() {
    return (
        <>
            <RedeemHero />
            <Above>
                <Stores />
                <Background />
            </Above>
            <Acceptants
                title="Benieuwd naar hoe jij jouw Lees! Cadeaukaart kan besteden?"
                description="Met de Lees! Cadeaukaart kun je je ontspannen dankzij het brede assortiment aan tijdschriften, boeken en e-books. Hier zie je al een aantal populaire items uit het brede assortiment van onze acceptanten. Het lezen van een romantisch verhaal? Een hip tijdschrift? Of toch een spannend e-book? De keuze is geheel aan jou!"
                buttons="none"
            />
        </>
    );
}
